import { createFileRoute } from '@tanstack/react-router'

// Any old `/account/api/...` path, so the parent's redirect sees it.
export const Route = createFileRoute('/_app/account/api/$')({})
